module.exports = __webpack_public_path__ + "static/media/diner_game.b088dbaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/dinerGame/diner_game.png
// module id = 2332
// module chunks = 0